import api from './api';

export interface TaskStatus {
  id: string;
  organizationId: string;
  name: string;
  color?: string;
  position: number;
  category: 'todo' | 'in_progress' | 'done';
  isDefault: boolean;
  createdAt: string;
  updatedAt?: string;
}

export interface CreateTaskStatusDto {
  name: string;
  color?: string;
  position: number;
  category: 'todo' | 'in_progress' | 'done';
  isDefault?: boolean;
}

export interface UpdateTaskStatusDto {
  name?: string;
  color?: string;
  position?: number;
  category?: 'todo' | 'in_progress' | 'done';
  isDefault?: boolean;
}

class TaskStatusService {
  async getTaskStatuses(): Promise<TaskStatus[]> {
    const response = await api.get('/taskstatuses');
    return response.data;
  }

  async getTaskStatus(id: string): Promise<TaskStatus> {
    const response = await api.get(`/taskstatuses/${id}`);
    return response.data;
  }

  async createTaskStatus(data: CreateTaskStatusDto): Promise<TaskStatus> {
    const response = await api.post('/taskstatuses', data);
    return response.data;
  }

  async updateTaskStatus(id: string, data: UpdateTaskStatusDto): Promise<TaskStatus> {
    const response = await api.put(`/taskstatuses/${id}`, data);
    return response.data;
  }

  async deleteTaskStatus(id: string): Promise<void> {
    await api.delete(`/taskstatuses/${id}`);
  }

  async reorderTaskStatuses(statusPositions: Record<string, number>): Promise<void> {
    await api.post('/taskstatuses/reorder', statusPositions);
  }
}

export const taskStatusService = new TaskStatusService();
